var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade-in-transition-slow","mode":"out-in"}},[(_vm.showHeader)?_c('div',{staticClass:"d-flex flex-grow-1 pb-1"},[_c('div',{staticClass:"d-flex align-center flex-grow-1"},[_vm._t("default")],2),_c('div',{staticClass:"d-flex align-center ml-2 mr-3"},[_vm._t("actions")],2)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }